module.exports = __webpack_public_path__ + "static/media/frontend.ac396843.svg";